<style lang="scss" src='./WhatsAppButton.scss' scoped></style>
<template src="./WhatsAppButton.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations,
    mapGetters,
  } from "vuex";
  export default {
    name: 'WhatsAppButton',
    props: {},
    components: {},
    data() {
      return {};
    },
    computed: {
        ...mapState(['showWAMessage']),
        ...mapGetters("Main", ['getCurrentStore']),
    },

    methods: {
        ...mapMutations(['setShowWAMessage']),

        fnShowWAMessage(){
            this.setShowWAMessage(true);
        },
        fnHideWAMessage(){
            this.setShowWAMessage(false);
        },

        fnGetWALink(){
            return "https://wa.me/" + "+521" + this.fnParseStoreWAPhone();
        },
        fnParseStoreWAPhone(){
            let waPhone = this.getCurrentStore.phone2;
            return waPhone.replaceAll(' ', '');
        }
    },
    beforeCreate() {},
    created() {},
    mounted() {},
    beforeDestroy() {},
  };

</script>